import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, testid }) => (
  <Reveal className="mb-10 flex items-center gap-4" data-testid={testid}>
    <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{index}</span>
    <span className="h-px w-10 bg-[#D4AF37]/40" aria-hidden="true" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#666666]">{label}</span>
  </Reveal>
);

export { EASE };
